
import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import RL1SlipImportLayout from "../../../components/RL1Slip/RL1SlipImportLayout/RL1SlipImportLayout";

export interface IRL1SlipImportPage {}

export const RL1SlipImportPage: FC<IRL1SlipImportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Import RL-1 Slip"
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Compliance", navigateTo: "/compliance/rl1/list" },
        { text: "RL-1", navigateTo: "/compliance/rl1/list" },
        { text: "Import RL-1 Slips", navigateTo: "/compliance/rl1/import" },
      ]}
      mainContents={<RL1SlipImportLayout />}
    />
  );
};
